import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Conversation } from '@app/models/conversation/conversation.model';

import { environment } from '../../../environments/environment';
import { ConversationsList } from '@app/models/conversation/conversationsList.model';
import { ConversationFilter } from '@app/models/conversation/conversationFilter.model';

@Injectable()
export class ConversationService {
  baseHref = `${environment.apiUrl}/conversations`;

  constructor(private http: HttpClient) {}

  getFilteredConversations(
    filter: ConversationFilter,
  ): Observable<ConversationsList> {
    const url = `${this.baseHref}`;
    let params = new HttpParams();
    Object.keys(filter).forEach((key) => {
      if (filter[key]) {
        params = params.set(key, filter[key]);
      }
    });
    return this.http.get<ConversationsList>(url, { params });
  }

  getRehireBarData(): Observable<Conversation[]> {
    const url = `${this.baseHref}/rehire`;
    return this.http.get<Conversation[]>(url);
  }

  getConversationMessages(conversationId: number): Observable<Conversation> {
    const url = `${this.baseHref}/${conversationId}/messages`;
    return this.http.get<Conversation>(url);
  }

  getConvId(offerId: number): Observable<any> {
    const url = `${this.baseHref}/offer/${offerId}`;
    return this.http.get<any>(url);
  }

  blockConversation(conversationId: number): Observable<any> {
    const url = `${this.baseHref}/${conversationId}/block`;
    return this.http.get<any>(url);
  }

  unblockConversation(conversationId: number): Observable<any> {
    const url = `${this.baseHref}/${conversationId}/unblock`;
    return this.http.get<any>(url);
  }
}
